// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"G--z"};